<template>
  <v-main>
    <AppBar/>
    <v-layout fill-height column>
      <v-container flex-fill fluid>
        <template v-if="!complete">
          <v-form class="form-item" v-model="valid">

            <label class="label">비밀번호</label>
            <div class="input-group">
              <v-text-field solo flat filled v-model="password" type="password" required
                            :rules="password_rule" placeholder="비밀번호(8~20자 영문, 숫자, 특수문자)"/>
            </div>

            <label class="label">비밀번호 확인</label>
            <div class="input-group">
              <v-text-field solo flat filled v-model="checkPasswd" type="password" required
                            :rules="checkPasswd_rule" placeholder="비밀번호 재입력"/>
            </div>
          </v-form>
        </template>
        <template v-else>
          <div class="d-flex flex-column justify-center align-center fill-height pb-14">
            <img :src="getImage('ic_check.svg')" class="mb-5">
            <div class="fs-18 blueGrayDarken4--text fw-700">비밀번호가 재설정되었습니다.</div>
          </div>
        </template>
      </v-container>

      <div class="footer-btns">
        <template v-if="!complete">
          <BlackBtn x-large str="확인" :disabled="!valid || (this.password!==this.checkPasswd)" @click="doChange"/>
        </template>
        <template v-else>
          <p class="text-center secondary--text mb-2">로그인 후 서비스를 이용해주세요</p>
          <BlackBtn x-large str="로그인" :disabled="complete!==true" ref="loginBtn" @click="goToLoginPage"/>
        </template>
      </div>

    </v-layout>
  </v-main>
</template>
<script>
import BlackBtn from "@/components/btns/BlackBtn";
import store from "@/store";

export default {
  data: () => ({
    valid: false,
    password: '',
    checkPasswd: '',
    complete: false,
    userKey: ''
  }),
  components: {
    BlackBtn,
  },
  mounted() {
    this.userKey = (store.getters.userKey === "") ? this.$route.params.userKey : store.getters.userKey;
  },
  computed: {
    password_rule() {
      return [
        v => !!v || "비밀번호를 올바르게 입력해주세요.",
        v => !(v && v.length <= 7) || '8자 이상 입력해주세요.',
        v => !!(v && /\d/.test(v)) || '숫자를 포함하여 입력해주세요.',
        v => !!(v && /[A-Za-z]/.test(v)) || '문자를 포함하여 입력해주세요.',
        v => !!(v && /[^A-Za-z0-9]/.test(v)) || '특수문자를 포함하여 입력해주세요.',
      ]
    },
    checkPasswd_rule() {
      return [
        v => v === this.password || '패스워드가 일치하지 않습니다.',
      ]
    }
  },
  methods: {
    goToLoginPage() {
      window.location.href = '/user/login'
    }
    , async doChange() {
      let updateSetData = {
        password: this.password
        , userKey: this.userKey
      };

      await store.dispatch('setMemberInfoInner', this.$_payload('inData', updateSetData))
          .then(res => {
            if (res.success) {
              this.complete = true;
              //this.$emit("")
            }
          }).catch(error => {
            console.error(error);
          }).finally(() => {
          })
    }
  },

}
</script>
<style lang="scss" scoped>
.v-input::v-deep {
  .v-text-field__details {
    padding-left: 0;
  }
}

.complete {

}
</style>
